<template>
  <div v-if="isLoading">
    <loading :active.sync="isLoading" color="#6666ff" :is-full-page="fullPage"></loading>
  </div>
  <div v-else>
    <div class="is-fullhd">
      <div class="columns" v-if="$cookie.get('role')==='superAdmin' || $cookie.get('role')==='companyAdmin'">
        <div class="column is-12">
          <div class="box">
            <div class="content" style="position: relative;">
              <h2 class="is-title is-bold has-text-centered has-text-primary teamMemberTitle">
                Team Member Dashboard
              </h2>
              <a href="/#/teamInfo" class="button is-primary is-outlined editTeamBtn">
                <i class="fa fa-pencil-square-o"></i><span class="is-hidden-mobile">&nbsp;Edit</span>
              </a>
            </div>
            <hr></hr>
            <div class="columns">
              <div class="column is-5">
                <chart id="summyryChart" :type="'bar'" :data="chartData" :options="options"></chart>
              </div>
              <div class="column is-7">
                <div class="table-container teamSummaryTable">
                  <small class="has-text-grey-light is-pulled-right">
                    <a @click="previewModal()">
                      <i class="fa fa-list-alt"></i> Reminder Preview
                    </a>
                  </small>
                  <table class="table is-bordered is-narrow is-fullwidth">
                    <thead>
                      <tr>
                        <th>Member</th>
                        <th style="min-width: 200px;">Status</th>
                        <th >Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="member in sortedMembers" >
                        <td>
                          {{member.member}}
                        </td>
                        <td v-if="member.status === 1">
                          <span class="icon" style="color: #b5b5b5;">
                            <i class="fa fa-square"></i>
                          </span>
                          Invited (not joined)
                        </td>
                        <td v-if="member.status === 2">
                          <span class="icon" style="color: #fce473;">
                            <i class="fa fa-square"></i>
                          </span>
                          Assessment pending
                        </td>
                        <td v-if="member.status === 3">
                          <span class="icon has-text-primary">
                            <i class="fa fa-square"></i>
                          </span>
                          Assessment Submitted
                        </td>
                        <td v-if="member.action">
                          <button class="button is-primary is-small">
                            <i class="fa fa-bell" @click="remind(member)"> Remind</i>
                          </button>
                        </td>
                        <td v-if="!member.action">
                          <button class="button is-primary is-small" disabled>
                            <i class="fa fa-bell"> Remind</i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <small class="has-text-grey-light">*TL = Team Leader</small>,
                  <small class="has-text-grey-light">TM = Team Member</small> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <div class="box">
            <div class="content" style="position: relative;">
              <h2 class="is-title is-bold has-text-centered has-text-primary">
                Assessment Dashboard
              </h2>
              <button class="button is-primary is-outlined editInitiativeBtn" v-if="$cookie.get('role')==='superAdmin' || $cookie.get('role')==='companyAdmin'" @click.prevent="editInitiative()">
                <i class="fa fa-pencil-square-o"></i><span class="is-hidden-mobile">&nbsp;Edit</span>
              </button>
            </div>
            <hr></hr>
            <div class="table-container initiativeSummaryTable">
              <table class="table is-bordered is-narrow is-fullwidth">
                <tbody>
                  <tr>
                    <td width="15%">
                      <strong style="color:#000">Status</strong>
                    </td>
                    <td v-if='!this.user.Submitted'>
                      <span class="icon" style="color: #fce473;">
                          <i class="fa fa-square"></i>
                        </span>
                        Assessment pending - 
                        <a href="/#/ChangeRiskAssessment">Do my Assessment</a>
                    </td>
                    <td v-if='this.user.Submitted'>
                      <span class="icon" style="color: #6666ff;">
                          <i class="fa fa-square"></i>
                        </span>
                        Assessment Submitted
                    </td>
                  </tr>
                  <tr>
                    <td width="15%">
                      <strong>Due Date</strong>
                    </td>
                    <td>
                      {{this.initiative.deadline}}
                      </td>
                  </tr>
                  <tr>
                    <td width="15%">
                      <strong>Team</strong>
                    </td>
                    <td>
                      {{this.initiative.teamName}}
                    </td>
                  </tr>
                  <tr>
                    <td width="15%">
                      <strong>Team Lead</strong>
                    </td>
                    <td>
                      {{this.initiative.teamLead}}
                    </td>
                  </tr>
                  <tr>
                    <td width="15%">
                      <strong>Initiative</strong>
                    </td>
                    <td>
                      {{this.initiative.name}}
                    </td>
                  </tr>
                  <tr>
                    <td width="15%">
                      <strong>Description</strong>
                    </td>
                    <td>
                      {{this.initiative.initiativeDetails}}
                      <a v-if="($cookie.get('role')==='superAdmin' || $cookie.get('role')==='companyAdmin') && !this.initiative.initiativeDetails" @click.prevent="editInitiative()">Update initiative description</a>
                    </td>
                  </tr>
                  <tr>
                    <td width="15%">
                      <strong>Organization</strong>
                    </td>
                    <td>
                      {{this.client.companyName}} &nbsp;
                      <a v-if="$cookie.get('role')==='superAdmin' || $cookie.get('role')==='companyAdmin'" @click.prevent="editInitiative()">Change logo</a>
                    </td>
                  </tr>                  
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
      
    <div class="modal welcomeModal" :class="{ isActive: notVisited }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <div class="content">
            <h2 class="is-title is-bold has-text-centered has-text-primary">
              Welcome to ChangeVU Free Trial
            </h2>
            <button class="delete" aria-label="close" @click="closeNotVisited()"></button>
          </div>
          <hr></hr>
          <p>
            Welcome to ChangeVU’s implementation change risk assessment!
          </p>
          <p>
            Please note that you should complete your assessment without consultation with any of your team members!
          </p>
          <p>
            Thank you for using ChangeVU!
          </p>
        </div>
      </div>
    </div>
      
    <div class="modal previewModal" :class="{ isActive: previewModalOpen }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box is-paddingless">
          <div class="preview-header has-text-centered">
            <img src="https://www.changevu.com/img/logo2x.png" href="https://www.changevu.com/" alt="ChangeVU" width="150px">
            <button class="delete" aria-label="close" @click="closePreviewModal()"></button>
          </div>
          <div class="preview-banner has-text-centered">
            <img src="https://www.changevu.com/img/banners/blogs.jpg" href="https://www.changevu.com/" alt="ChangeVU">
          </div>
          <div class="preview-body has-text-white">
            <div class="content">
              <h2 class="has-text-white">
                Reminder: Change Risk Assessment
              </h2>
              <p>
                Hi there,
              </p>
              <p>
                 You've been invited by {{this.initiative.teamLead}} to a free change risk assessment.<br />
                 The deadline for completing the assessment is {{this.initiative.deadline}}
              </p>
              <p>
                Click the button below to login and run your assessment.
              </p>
              <p style="margin-bottom: 0rem !important;">
                Your team details:
              </p>
              <table class="table">
                <tbody>
                  <tr>
                    <td width="125px">Team Name:</td>
                    <td>{{ this.initiative.teamName }}</td>
                  </tr>
                  <tr>
                    <td width="125px">Team Leader:</td>
                    <td>{{ this.initiative.teamLead }}</td>
                  </tr>
                  <tr>
                    <td width="125px">Initiative name:</td>
                    <td>{{ this.initiative.name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="preview-body-button">
            <div class="content">
              <p class="has-text-centered">
                <button class="button is-primary has-text-black">Run Assessment</button>
              </p>
            </div>
          </div>
          <div class="preview-body has-text-white">
            <div class="content">
              <p>
                If you have any questions <a href="#" class="link">Click here.</a><br /><br />
                Thanks,<br />ChangeVU Team
              </p>
            </div>
          </div>
          <div class="preview-footer">
            <div class="footer-img">
              <img src="https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg" alt="Connect to better change navigation">
            </div>
            <p class="has-text-centered">
              <a href="#" style="color: #9B9B9B;">Unsubscribe</a> to stop receiving these emails from us.<br/>
              Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9<br/>
              © 2020 Straticom Technologies R&D, all rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as globalConstants from '../globalConstants.js'
import {Datetime} from 'vue-datetime'
import Chart from 'vue-bulma-chartjs'
import router from '../router'
import Loading from 'vue-loading-overlay'

import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    datetime: Datetime,
    Chart,
    Loading
  },
  data () {
    return {
      fullPage: true,
      isLoading: true,
      modalOpen: false,
      notVisited: true,
      previewModalOpen: false,
      user: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        type: '',
        role: '',
        Submitted: false
      },
      client: {
        id: '',
        companyName: '',
        contactPerson: {
          firstName: '',
          lastName: '',
          email: '',
          role: ''
        }
      },
      initiative: {
        id: '',
        name: '',
        deadline: '',
        teamName: '',
        initiativeDetails: '',
        members: []
      },
      sortedMembers: [],
      showInitiative: false,
      pictureName: '',
      data: {
        labels: ['Invited', 'Pending', 'Submitted'],
        datasets: [{
          data: [0, 0, 0],
          backgroundColor: [
            '#b5b5b5',
            '#fce473',
            '#6666ff'
          ]
        }]
      },
      options: {
        title: {
          display: true,
          text: 'Team Member Assessment Status'
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              stepSize: 2
            }
          }],
          xAxes: [{
            ticks: {
              fontSize: 10,
              fontStyle: 600
            },
            barPercentage: 0.5
          }]
        }
      },
      invitedNo: 0,
      PendingNo: 0,
      CompletedNo: 0
    }
  },
  computed: {
    chartData: function () {
      this.data.datasets[0].data[0] = this.invitedNo
      this.data.datasets[0].data[1] = this.PendingNo
      this.data.datasets[0].data[2] = this.CompletedNo
      return this.data
    }
  },
  created () {
    let isVisited = JSON.parse(window.localStorage.getItem('visited'))
    if (isVisited && isVisited.status) {
      this.notVisited = false
    } else {
      window.localStorage.setItem('visited', JSON.stringify({status: true}))
    }
    let user = JSON.parse(window.localStorage.getItem('user'))
    this.user = user
    this.user.Submitted = user.diagonacticStatus
    axios.get(globalConstants.apiURL + '/api/v1/createdInitiatives/' + user._id)
    .then(response => {
      if (response.data.length > 0) {
        this.initiative.id = response.data[0]._id
        this.initiative.teamLead = response.data[0].teamLead.firstName + ' ' + response.data[0].teamLead.lastName
        this.initiative.teamName = response.data[0].teamName
        this.initiative.name = response.data[0].initiativeName
        this.initiative.deadline = new Date(response.data[0].deadline).toLocaleString()
        this.initiative.members = response.data[0].members
        this.initiative.initiativeDetails = response.data[0].initiativeDescription
        // not joined, status 1
        let notJoined = 0
        for (let j = 0; j < this.initiative.members.length; j++) {
          if (!this.initiative.members[j].user.joining) {
            this.sortedMembers.push({'member': this.initiative.members[j].user.email, 'role': 'TM', 'status': 1, 'action': true, 'id': this.initiative.members[j].user._id})
            notJoined++
          }
        }
        // Assessment pending, status 2
        let assessmentPending = 0
        for (let j = 0; j < this.initiative.members.length; j++) {
          if (this.initiative.members[j].user.joining && !this.initiative.members[j].user.diagonacticCompleted) {
            let role = 'TM'
            let action = true
            if (this.initiative.members[j].user.type === 'companyAdmin') {
              role = 'TL'
              action = false
            }
            this.sortedMembers.push({'member': this.initiative.members[j].user.firstName + ' ' + this.initiative.members[j].user.lastName + '\n' + ' (' + this.initiative.members[j].user.email + ')', 'role': role, 'status': 2, 'action': action, 'id': this.initiative.members[j].user._id})
            assessmentPending++
          }
        }
        // Assessment complete, status 3
        let assessmentComplete = 0
        for (let j = 0; j < this.initiative.members.length; j++) {
          if (this.initiative.members[j].user.joining && this.initiative.members[j].user.diagonacticCompleted) {
            let role = 'TM'
            if (this.initiative.members[j].user.type === 'companyAdmin') {
              role = 'TL'
            }
            this.sortedMembers.push({'member': this.initiative.members[j].user.firstName + ' ' + this.initiative.members[j].user.lastName + '\n' + ' (' + this.initiative.members[j].user.email + ')', 'role': role, 'status': 3, 'action': false, 'id': this.initiative.members[j].user._id})
            assessmentComplete++
          }
        }
        // update chart
        this.invitedNo = notJoined + assessmentPending + assessmentComplete
        this.PendingNo = assessmentPending
        this.CompletedNo = assessmentComplete
        this.data.datasets[0].data[0] = this.invitedNo
        this.data.datasets[0].data[1] = this.PendingNo
        this.data.datasets[0].data[2] = this.CompletedNo
        window.localStorage.setItem('Initiative', JSON.stringify({id: response.data[0]._id}))
        axios.get(globalConstants.apiURL + '/api/v1/users/' + user._id)
          .then(response1 => {
            this.$store.commit('setAssessmentCompleted', response1.data.diagonacticCompleted)
            axios.get(globalConstants.apiURL + '/api/v1/clients/' + response1.data.client)
            .then(response2 => {
              this.client.companyName = response2.data.companyName
              this.client.contactPerson = response2.data.contactPerson
              this.client.id = response2.data._id
              if (response2.data.logoPath) {
                this.$store.commit('setClientLogoSrc', globalConstants.apiURL + '/' + response2.data.logoPath)
              }
            })
            .catch(error => {
              console.log(error)
            })
          })
          .catch(error => {
            console.log(error)
          })
      }
      this.isLoading = false
    })
    .catch(error => {
      if (error.response.status === 401) {
        this.logout()
      }
    })
  },
  methods: {
    logout () {
      window.localStorage.removeItem('Initiative')
      window.localStorage.removeItem('user')
      this.$cookie.delete('role')
      this.$cookie.delete('token')
      this.$auth.logout({
        makeRequest: false,
        success: function () {
          router.push({ path: '/login' })
        }
      })
    },
    fileChange () {
      var image = document.getElementById('logo').files[0]
      this.pictureName = image.name
    },
    editInitiative () {
      router.push({ path: '/assessmentInfo' })
    },
    closeNotVisited () {
      this.notVisited = !this.notVisited
    },
    previewModal () {
      this.previewModalOpen = !this.previewModalOpen
    },
    closePreviewModal () {
      this.previewModalOpen = !this.previewModalOpen
    },
    remind (item) {
      axios.post(globalConstants.apiURL + '/api/v1/remind', {inviter: this.user, 'initiativeID': this.initiative.id, 'userID': item.id})
        .then(response => {
          console.log(response)
          this.$noty.success('Reminder sent successfully.')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.isActive {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.teamMemberTitle {
  @media screen and (max-width: 425px) {
    font-size: 1.6rem !important;
  }
}
.modal {
  top: 65px !important;
  height: 100%;
  @media screen and (max-width: 999px) {
    justify-content: flex-start;
    flex-direction: column;
    .modal-content {
      margin-top: 15%;
      max-height: calc(100vh - 160px) !important;
    }
  }
  .modal-content {
    // -ms-overflow-style: none;
    // scrollbar-width: none; 
    // overflow: -moz-scrollbars-none;
    // &::-webkit-scrollbar {
    //   display: none;
    // }
  }
}

.editInitiativeModal {
  .box {
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0px;
    }
  }
}

.welcomeModal {
  .modal-content {
    border-radius: 10px;
  }
  .box {
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0px;
    }
    p {
      margin-bottom: 1rem;
    }
  }
}

.modal-background {
  opacity: .5 !important;
}

.editInitiativeBtn {
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 0.25em;
  height: auto;
  @media screen and (max-width: 768px) {
    top: -15px;
    right: -15px;
  }
}

.initiativeSummaryTable {
  .table td, .table th {
    vertical-align: middle;
    .content {
      h4 {
        margin-bottom: 0rem !important;
      }
      sub {
        font-size: 60% !important;
      }
    }
  }
  .table tr:hover {
    background: none;
  }
  table {
    margin-bottom: 0rem;
    border-collapse: separate;
    tbody {
      tr:first-child {
        td {
          &:first-child {
            border-radius: 10px 0 0 0;
            width: 15%;
            min-width: 125px
          }
          &:last-child {
            border-radius: 0 10px 0 0;
            min-width: 200px
          }
        }
      }
      tr:last-child {
        td {
          &:first-child {
            border-radius: 0px 0 0 10px;
          }
          &:last-child {
            border-radius: 0 0px 10px 0;
          }
        }
      }
    }
  }
}

.editTeamBtn {
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 0.25em;
  height: auto;
  @media screen and (max-width: 768px) {
    top: -15px;
    right: -15px;
  }
}

.teamSummaryTable {
  margin-top: 1rem;
  .table tr:hover {
    background: none;
  }
  table {
    margin-bottom: 0rem;
    border-collapse: separate;
    thead {
      tr:first-child {
        th {
          &:first-child {
            border-radius: 10px 0 0 0;
          }
          &:last-child {
            border-radius: 0 10px 0 0;
          }
        }
      }
    }
    tbody {
      tr:last-child {
        td {
          &:first-child {
            border-radius: 0px 0 0 10px;
          }
          &:last-child {
            border-radius: 0 0px 10px 0;
          }
        }
      }
    }
  }
}

.table-container {
  // -webkit-overflow-scrolling: touch;
  overflow: auto;
  overflow-y: hidden;
  max-width: 100%;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar:vertical {
    width: 12px;
  }

  &::-webkit-scrollbar:horizontal {
    height: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, .5);
    border-radius: 10px;
    border: 2px solid #ffffff;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;  
    background-color: #ffffff; 
  }
  table {
    margin-bottom: 0rem;
  }
}

.buttons {
  button {
    margin-bottom: .5rem;
  }
}

.previewModal {
  .modal-content {
    border-radius: 10px;
  }
  .preview-header {
    padding: 10px;
    position: relative;
    border-radius: 10px 10px 0px 0px;
    .delete {
      position: absolute;
      right: 5px;
      top: 5px;
    }
  }
  .preview-banner {
    background-color: #6666ff;
  }
  .preview-body {
    background-color: #6666ff;
    padding: 1rem;
    .content {
      h2 {
        margin-bottom: 1rem !important;
      }
      p {
        margin-bottom: 1rem !important;
      }
      .table {
        background-color: transparent;
        color: #fff;
        line-height: 1;
        tr {
          &:hover {
            background-color: transparent !important;
          }
          border: none !important;
          td {
            border: none !important;
            padding: 0.25em 0em;
          }
        }
      }
      .link {
        color: #FFF !important;
        font-weight: 600;
        text-decoration: underline;
        font-size: 14px;
      }
    }
  }
  .preview-body-button {
    padding: 1.5rem 0rem;
    .button {
      font-weight: 600;
      font-size: 1.25rem;
    }
  }
  .preview-footer {
    color: #9B9B9B;
    background-color: #eee;
    padding: 0rem 0rem 1rem;
    border-radius: 0px 10px 10px 0px;
    a {
      text-decoration: underline;
    }
  }
}
</style>

<style lang="scss">
.deadlineInput {
  .vdatetime-input {
    padding-left: 2.25em;
    -moz-appearance: none;
    -webkit-appearance: none;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 3px;
    box-shadow: none;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-size: 1rem;
    height: 2.25em;
    -ms-flex-pack: start;
    justify-content: flex-start;
    line-height: 1.5;
    padding-bottom: calc(0.375em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
    position: relative;
    vertical-align: top;
    background-color: #fff;
    border-color: #dbdbdb;
    color: #363636;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    max-width: 100%;
    width: 100%;
  }
}
.modal-content {
  max-height: calc(100vh - 160px) !important;
}
</style>



// WEBPACK FOOTER //
// Home.vue?0bdded19